<template>
  <div class="flex flex-row v-center title">
    <span class="widget-icon" :class="iconClass"></span><span>{{ title }}</span>
  </div>
</template>
<script>
export default {
  name: "icon-title",
  props: {
    type: Number,
    title: String,
  },
  computed: {
    isTable() {
      return this.$props.type === 2;
    },
    isForm() {
      return this.$props.type === 1;
    },
    iconClass() {
      const { isTable, isForm } = this;
      return {
        "icon-table": isTable,
        "icon-form": isForm,
      };
    },
  },
};
</script>
<style scoped>
.title .widget-icon {
  margin: auto;
  width: 30px;
  height: 30px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 50%;
  display: inline-block;
}
.title .widget-icon.small {
  background-size: 50% 50%;
  /* width: 15px;
        height: 15px; */
}
.title .widget-icon.icon-form {
  background-image: url(../../assets/icon-form.png);
}
.title .widget-icon.icon-table {
  background-image: url(../../assets/icon-table.png);
}
</style>
